var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.5 11.1212H17.61C15.24 11.1212 13.31 9.19115 13.31 6.82115V3.93115C13.31 3.38115 12.86 2.93115 12.31 2.93115H8.07C4.99 2.93115 2.5 4.93115 2.5 8.50115V17.3612C2.5 20.9312 4.99 22.9312 8.07 22.9312H15.93C19.01 22.9312 21.5 20.9312 21.5 17.3612V12.1212C21.5 11.5712 21.05 11.1212 20.5 11.1212Z",
    fill: "#5B6B79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8001 3.14115C15.3901 2.73115 14.6801 3.01115 14.6801 3.58115V7.07115C14.6801 8.53115 15.9201 9.74115 17.4301 9.74115C18.3801 9.75115 19.7001 9.75114 20.8301 9.75114C21.4001 9.75114 21.7001 9.08115 21.3001 8.68115C19.8601 7.23114 17.2801 4.62115 15.8001 3.14115Z",
    fill: "#5B6B79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.6812H7.5C7.09 14.6812 6.75 14.3412 6.75 13.9312C6.75 13.5212 7.09 13.1812 7.5 13.1812H13.5C13.91 13.1812 14.25 13.5212 14.25 13.9312C14.25 14.3412 13.91 14.6812 13.5 14.6812Z",
    fill: "#5B6B79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18.6812H7.5C7.09 18.6812 6.75 18.3412 6.75 17.9312C6.75 17.5212 7.09 17.1812 7.5 17.1812H11.5C11.91 17.1812 12.25 17.5212 12.25 17.9312C12.25 18.3412 11.91 18.6812 11.5 18.6812Z",
    fill: "#5B6B79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.07fe84a3eee071026980801aa18132d3.svg";
export { ForwardRef as ReactComponent };